import React from 'react';

// TODO: Get this type from VM once its added
export type Details = {
  vehicleId: number;
  name: string;
  capacity: string;
  eta?: string;
  dimensions?: string;
};

export interface VehicleDetailsProps {
  vehicleDetails: Details;
  isExpanded?: boolean;
}

const VehicleDetails: React.FC<VehicleDetailsProps> = ({
  vehicleDetails: { vehicleId, name, capacity, eta, dimensions },
  isExpanded = false,
}) => {
  return (
    <div
      id={`${vehicleId}-vehicle-details`}
      className="flex flex-col flex-1 items-start space-y-2 ml-6"
    >
      {isExpanded && (
        <div id={`${vehicleId}-vehicle-name`} className={`text-2xl font-bold`}>
          {name}
        </div>
      )}
      <div
        className={`flex items-center font-semibold text-xl space-x-2 ${isExpanded ? 'text-[#2D2F34] ' : 'text-[#707582] '}`}
      >
        <div id={`${vehicleId}-vehicle-capacity`}>{capacity}</div>
        <div
          id={`${vehicleId}-vehicle-eta`}
          className="w-[2px] h-[2px] bg-slate-600 rounded-full"
        />
        {eta && <div>{eta}</div>}
      </div>

      {isExpanded && dimensions && (
        <div
          id={`${vehicleId}-vehicle-dimensions`}
          className={`text-[#2D2F34] text-xl font-semibold`}
        >
          {dimensions}
        </div>
      )}
    </div>
  );
};

export default VehicleDetails;
